import { Row, Col, Button } from "react-bootstrap";
import { Bell, Calendar, Maximize, Moon, Plus, Power, Sun } from "lucide-react";
import { useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "@global/actions";
import { setIsLogged, setToken, setData, setMode } from "@auth/Actions";
import LangChanger from "@layout/LangChanger";

function Header({ profile, theme }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
 const { sectionName, isLoading  } = useSelector((state) => state.global);
console.log('sectionname',sectionName)

  const handleLogout = async () => {
    const confirmed = window.confirm(t("logout_warning"));
    if (!confirmed) return;

    dispatch(setIsLogged(false));
    dispatch(setToken(""));
    dispatch(setData([]));
    window.location = "/login";
  };

  const toggleDark = (mode) => {
    dispatch(setMode(mode));
    dispatch(setLoading(true));
    setTimeout(() => {
      dispatch(setLoading(false));
    }, 1000);
  };

  const handleFullscreenToggle = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };

  const getMode = () => {
    if (profile.mode === "light") {
      return (
        <span
          className="ms-4"
          role="button"
          title={t("dark_mode")}
          onClick={() => toggleDark("dark")}
        >
          <Moon size={20} strokeWidth={1.3} color="#2A3650" fill="#2A3650" />
        </span>
      );
    }
    
    return (
      <span
        className="ms-4"
        role="button"
        title={t("light_mode")}
        mode="light"
        onClick={() => toggleDark("light")}
      >
        <Sun size={20} strokeWidth={1.3} color="#EFDF2B" fill="#EFDF2B" />
      </span>
    );
  };

  return (
    <header className={`w-100 bg-transparent border-0 ${theme.nav} d-md-flex justify-content-between py-3 px-4`}>
      <div className="text-dark fs-3 fw-medium d-none d-md-block">
        {t(sectionName)}
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <span className="ms-4 bg-secondary-blue p-2 rounded-3 text-blue" role="button" title={t("notifications")}>
          <Bell size={20} strokeWidth={1.3} />
        </span>

        <span
          className="ms-4 bg-secondary-blue p-2 rounded-3 text-blue d-none d-md-block"
          role="button"
          title={t("full_screen")}
          onClick={handleFullscreenToggle}
        >
          <Maximize size={20} strokeWidth={1.3} />
        </span>

        <span className="ms-4 bg-secondary-blue p-2 rounded-3 text-blue" title={t("langs")}>
          <LangChanger t={t} location={location}/>
        </span>
      </div>
    </header>
  );
}

export default Header;